import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ContenutoGenericoService} from '../service/contenuto-generico.service';
import {ContenutoGenerico} from '../model/contenuto-generico';
import {AllegatoService} from '../service/allegato.service';
import {Allegato} from '../model/allegato';
import {Search} from '../common/search';
import {CONTATTI, DOCS_REPLACE} from '../constants/constants';
import {NewsService} from '../service/news.service';
import {News} from '../model/news';
import {SeoService} from '../service/seo.service';

@Component({
    selector: 'app-contatti',
    templateUrl: './contatti.component.html',
})
export class ContattiComponent implements OnInit {

    public componente: string = null;
    public element: ContenutoGenerico;
    public allegato: Allegato;
    public sottoGruppi: Array<ContenutoGenerico>;
    public loading: boolean;
    public path_immagine: string;
    public newsList: Array<News>;
    public lingua: string;

    constructor(private contenutoService: ContenutoGenericoService,
                private allegatoService: AllegatoService,
                private newsService: NewsService,
                private seoService: SeoService,
                public route: ActivatedRoute) {
    }

    ngOnInit() {
        this.contenutoService.find(CONTATTI).subscribe(gruppo => {
            this.element = gruppo;
            this.lingua = this.element.lang;
            this.allegatoService.find(gruppo.immagine).subscribe(allegato => {
                if (allegato) {
                    this.allegato = allegato;
                    this.path_immagine = DOCS_REPLACE(allegato.uuid);
                    this.seoService.setImage(this.path_immagine);
                }
            });
            this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
            this.contenutoService.search._.contenitore = CONTATTI;
            this.contenutoService.search._.lang = this.lingua;
            this.contenutoService.getAllList().subscribe(sottoGruppi => {
                this.sottoGruppi = sottoGruppi;
                this.loading = true;
            });
            this.newsService.search._sort = 'data_pubblicazione DESC';
            this.newsService.search._limit = 2;
            this.newsService.getList().subscribe(newsList => {
                this.newsList = newsList;
            });
        });
    }

}


